import { isObject, isString } from '../../is';
// export const defaultHandler: Handler = (value, source, config): any => {
//   return value;
// };
export function patternParser(pattern) {
  const [, root, , children] = pattern.match(/^([^<>]*)(<(.*)>)?$/) || [];
  if (!root) return null;
  let [, prop, , newProp, , initValue] = root.match(/^([^:=]*)(:([^=<>]*))?(=(.*))?/) || [];
  // todo
  if (!prop) return null;
  const target = {
    prop,
    newProp,
    initValue: initValueParser(initValue)
  };
  if (children) {
    let temp = splitter(children)
      .filter(Boolean)
      .map(e => patternParser(e));
    temp = temp.filter(Boolean);
    if (temp.length) target.children = temp;
  }
  return target;
}

export function patternsParser(patterns) {
  const targets = splitter(patterns)
    .map(pattern => {
      return patternParser(pattern);
    })
    .filter(Boolean);
  return targets;
}

export function propParser(source, prop) {
  const reg = /^(?!\..+)(?!.*\.\.)(?!.+\.$).*$/;
  if (!reg.test(prop) || !isString(prop) || !prop) {
    throw new Error(`[TRANSFROM_STRUCT]:Error while resolving the prop: ${prop}`);
  }
  const chain = prop.split('.');
  const res = chain.reduce((temp, p) => {
    return isObject(temp) ? temp[p] : null;
  }, source);
  return res;
}

export function initValueParser(expression) {
  if (!isString(expression) || expression === '') return undefined;
  return Function(`return ${expression}`)();
}

export function splitter(str) {
  if (!str) return [];
  const seperators = ['<', '>', ','];
  const regexp = new RegExp(`(\\${seperators.join('|\\')})`);
  if (!regexp.test(str)) return [str];
  const tokens = str.split(regexp);
  const rules = [];
  let word = '';
  let words = '';
  let deep = 0;
  let isEnd = false;
  for (let index = 0; index < tokens.length; index++) {
    word = tokens[index];
    isEnd = index === tokens.length - 1;
    if (word === seperators[0]) deep++;
    if (word === seperators[1]) deep--;
    if (deep < 0) {
      throw new Error(`[TRANSFROM_STRUCT]Error in parsing, word:"${word}"-index: ${index + 1}`);
    }
    if (deep === 0 && (seperators.slice(1).includes(word) || isEnd)) {
      if (word === seperators[1] || isEnd) words += word;
      words && rules.push(words);
      words = '';
    } else {
      words += word;
    }
  }
  return rules;
}
